<template>
    <div class="dataCenter">
        <iframe :src="url" frameborder="0"></iframe>
    </div>
</template>

<script>
import common from "@common/common";
import { apis } from "@common/config";

export default {
    data() {
        return {
            url: ''
        }
    },
    methods: {
        getDataCenter() {
            if(this.$route.query.admin_type){
                let info = {
                    admin_type: this.$route.query.admin_type
                }
                common
                .myFetch(apis.dataCenterRedirect, info)
                .then(r => {
                    if (r) {
                        console.log(r)
                        this.url = r
                    }
                });
            }else{
                common
                .myFetch(apis.dataCenterRedirect)
                .then(r => {
                    if (r) {
                        console.log(r)
                        this.url = r
                    }
                });
            }
        }
    },
    mounted() {
        console.log(this.$route.query.admin_type)
        this.getDataCenter()
    }
}
</script>

<style lang="less" scoped>
    .dataCenter {
        width: 100vw;
        height: calc(100vh - 70px);
        overflow: hidden;

        iframe {
            width: 100%;
            height: 100%;
        }
    }
</style>